import { ReactElement } from 'react'

import { shouldShowEndTime } from '@/helpers/tools'
import { ShiftViewModel } from '@/models'
import { SettingResource } from '@/models/Setting'
import { getDepartmentName } from '@/services/DepartmentService/getDepartmentName'
import { getShiftTime } from '@/services/ShiftService/getShiftTime'

function getShiftLabel(shift: ShiftViewModel, userId?: string, settings: SettingResource[] = []) {
    const shiftPlanning = shift.shiftPlannings
        .find((planning) => (planning.user && planning.user.id === userId))
    const canViewShiftEndTime = shouldShowEndTime(settings, shift?.department?.id)
    const shiftTime = getShiftTime(shiftPlanning || shift, canViewShiftEndTime)
    const departmentName = shift.department ? getDepartmentName(shift.department) : shift.department

    return `${departmentName} - ${shiftTime}`
}

export function getShiftSelectOptions(
    shifts: ShiftViewModel[],
    userId?: string,
    settings: SettingResource[] = [],
): ReactElement[] {
    return shifts.map(shift => (
        <option
            key={shift.id}
            value={shift.id}
        >
            {getShiftLabel(shift, userId, settings)}
        </option>
    ))
}
